// Module
var code = "<div> <wt-property-grid-table fields=\"vm.properties\" form-controller=\"vm.formController\" item=\"vm.configuration\" modern-design=\"true\"> </wt-property-grid-table> <wt-validation-errors form-controller=\"vm.formController\" fields=\"vm.properties\"> </wt-validation-errors> </div>";
// Exports
module.exports = code;